export default __webpack_public_path__ + "static/media/alert.255d9336.png";